module.exports = __webpack_public_path__ + "static/media/glyph-experience.51a546ed.svg";